export interface Movie {
  id: string;
  title: string;
  year: string;
  category: 'movie' | 'tv' | 'variety';
  subCategory: string;
  rating: string;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  updateDate: string;
  episodes: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export const movies: Movie[] = [
  {
    id: 'movie-001',
    title: '流浪地球2',
    year: '2023',
    category: 'movie',
    subCategory: '科幻',
    rating: '8.3',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20The%20Wandering%20Earth%202%2C%20dramatic%20space%20theme%20with%20astronauts%20and%20earth%2C%20cinematic%20lighting%20with%20deep%20blues%20and%20oranges%2C%20movie%20poster%20style%20with%20Chinese%20title%2C%20epic%20scale%2C%20high%20contrast%2C%20professional%20film%20poster%20design&width=400&height=560&seq=movie-001&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    region: '中国大陆',
    duration: '173分钟',
    updateDate: '2024-12-20',
    episodes: '1',
    isHot: true,
    isNew: false,
    tags: ['科幻', '灾难', '冒险'],
  },
  {
    id: 'movie-002',
    title: '满江红',
    year: '2023',
    category: 'movie',
    subCategory: '剧情',
    rating: '7.5',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20Full%20River%20Red%2C%20ancient%20Chinese%20palace%20setting%20with%20red%20lanterns%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20traditional%20Chinese%20aesthetic%2C%20film%20poster%20design%20with%20calligraphy%20title%2C%20warm%20red%20and%20gold%20tones&width=400&height=560&seq=movie-002&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    duration: '159分钟',
    updateDate: '2024-11-15',
    episodes: '1',
    isHot: true,
    isNew: false,
    tags: ['剧情', '喜剧', '悬疑'],
  },
  {
    id: 'movie-003',
    title: '长津湖',
    year: '2021',
    category: 'movie',
    subCategory: '战争',
    rating: '7.4',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20Battle%20of%20Chosin%20Reservoir%2C%20soldiers%20in%20snow%20battlefield%2C%20dramatic%20winter%20warfare%20scene%2C%20heroic%20atmosphere%2C%20cold%20blue%20tones%20with%20fire%20contrast%2C%20epic%20war%20film%20poster%20style%2C%20professional%20movie%20poster&width=400&height=560&seq=movie-003&orientation=portrait',
    description: '1950年，中国志愿军部队在极度严酷的环境下，东线作战部队凭着钢铁意志和英勇无畏的战斗精神，扭转战场态势，打出了军威国威。',
    director: '陈凯歌',
    actors: ['吴京', '易烊千玺', '段奕宏', '朱亚文'],
    region: '中国大陆',
    duration: '176分钟',
    updateDate: '2024-10-08',
    episodes: '1',
    isHot: false,
    isNew: false,
    tags: ['战争', '历史', '动作'],
  },
  {
    id: 'movie-004',
    title: '哪吒之魔童降世',
    year: '2019',
    category: 'movie',
    subCategory: '动画',
    rating: '8.4',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20NeZha%2C%20mythological%20character%20with%20flaming%20wheels%20and%20red%20silk%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%20with%20fire%20and%20smoke%20effects%2C%20Chinese%20animation%20style%2C%20epic%20fantasy%20film%20poster&width=400&height=560&seq=movie-004&orientation=portrait',
    description: '天地灵气孕育出一颗混元珠，元始天尊将混元珠提炼成灵珠和魔丸。灵珠投胎为人，助周伐纣时可堪大用；而魔丸则会诞出魔王，为祸人间。',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '陈浩'],
    region: '中国大陆',
    duration: '110分钟',
    updateDate: '2024-09-22',
    episodes: '1',
    isHot: false,
    isNew: false,
    tags: ['动画', '奇幻', '喜剧'],
  },
  {
    id: 'movie-005',
    title: '孤注一掷',
    year: '2023',
    category: 'movie',
    subCategory: '犯罪',
    rating: '7.0',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20No%20More%20Bets%2C%20dark%20gambling%20theme%20with%20playing%20cards%20and%20money%2C%20tense%20atmosphere%2C%20neon%20lights%20in%20darkness%2C%20suspenseful%20film%20poster%20design%2C%20modern%20thriller%20aesthetic&width=400&height=560&seq=movie-005&orientation=portrait',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君'],
    region: '中国大陆',
    duration: '130分钟',
    updateDate: '2024-12-01',
    episodes: '1',
    isHot: true,
    isNew: false,
    tags: ['犯罪', '剧情', '悬疑'],
  },
  {
    id: 'movie-006',
    title: '消失的她',
    year: '2023',
    category: 'movie',
    subCategory: '悬疑',
    rating: '7.3',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20thriller%20movie%20poster%20Lost%20in%20the%20Stars%2C%20couple%20silhouette%20on%20tropical%20beach%2C%20mysterious%20and%20suspenseful%20atmosphere%2C%20dark%20ocean%20and%20starry%20sky%2C%20film%20noir%20style%2C%20elegant%20and%20haunting%20movie%20poster&width=400&height=560&seq=movie-006&orientation=portrait',
    description: '何非的妻子李木子在结婚周年旅行中消失，当他苦寻无果之时，妻子再次现身，何非却坚称眼前的女人并非自己的妻子。随着金牌律师陈麦介入其中，更多谜团浮现。',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    region: '中国大陆',
    duration: '122分钟',
    updateDate: '2024-11-28',
    episodes: '1',
    isHot: false,
    isNew: true,
    tags: ['悬疑', '犯罪', '剧情'],
  },
  {
    id: 'movie-007',
    title: '热烈',
    year: '2023',
    category: 'movie',
    subCategory: '喜剧',
    rating: '7.6',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20dance%20comedy%20movie%20poster%20One%20and%20Only%2C%20street%20dance%20theme%20with%20breakdancer%20in%20dynamic%20pose%2C%20vibrant%20colorful%20lighting%2C%20youthful%20energy%2C%20urban%20street%20style%2C%20inspiring%20and%20energetic%20film%20poster%20design&width=400&height=560&seq=movie-007&orientation=portrait',
    description: '街舞老炮儿丁雷偶遇卖艺少年陈烁，丁雷忽悠陈烁加入自己经营的舞团。舞团内高手如云，性格各异，与陈烁碰撞出不同的火花，笑料不断。',
    director: '大鹏',
    actors: ['黄渤', '王一博', '刘敏涛', '岳云鹏'],
    region: '中国大陆',
    duration: '124分钟',
    updateDate: '2024-12-10',
    episodes: '1',
    isHot: false,
    isNew: true,
    tags: ['喜剧', '剧情', '运动'],
  },
  {
    id: 'movie-008',
    title: '封神第一部',
    year: '2023',
    category: 'movie',
    subCategory: '奇幻',
    rating: '7.8',
    poster: 'https://readdy.ai/api/search-image?width=400&height=560&seq=movie-008&orientation=portrait&query=Chinese%20fantasy%20epic%20movie%20poster%20Creation%20of%20the%20Gods%2C%20ancient%20Chinese%20mythology%20warriors%20with%20armor%2C%20dramatic%20battle%20scene%2C%06olden%20and%20bronze%20tones%2C%20mythical%20creatures%20silhouettes%2C%20epic%20scale%20fantasy%20film%20poster',
    description: '殷商末年，纣王暴虐无道，宠信妲己。昆仑仙人姜子牙携封神榜下山，寻找天下共主。西伯侯之子姬发觉醒，带领众人反抗暴政，封神大战一触即发。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    region: '中国大陆',
    duration: '148分钟',
    updateDate: '2024-10-30',
    episodes: '1',
    isHot: false,
    isNew: false,
    tags: ['奇幻', '动作', '战争'],
  },
  {
    id: 'movie-009',
    title: '热辣滚烫',
    year: '2024',
    category: 'movie',
    subCategory: '剧情',
    rating: '7.9',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20comedy%20movie%20poster%20YOLO%2C%20boxing%20ring%20theme%20with%20female%20boxer%20in%20training%2C%20warm%20golden%20lighting%2C%20inspiring%20and%20motivational%20atmosphere%2C%20weight%20loss%20transformation%20theme%2C%20emotional%20film%20poster%20design&width=400&height=560&seq=movie-009&orientation=portrait',
    description: '乐莹是一个善良但缺乏自信的女孩，在经历了生活的种种挫折后，她决定通过拳击改变自己的人生。这是一段关于成长、自我突破和重新认识自己的故事。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    region: '中国大陆',
    duration: '129分钟',
    updateDate: '2024-12-25',
    episodes: '1',
    isHot: true,
    isNew: true,
    tags: ['剧情', '喜剧', '运动'],
  },
  {
    id: 'movie-010',
    title: '八角笼中',
    year: '2023',
    category: 'movie',
    subCategory: '剧情',
    rating: '7.5',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%20Octagonal%2C%20MMA%20fighting%20cage%20theme%20with%20young%20fighters%2C%20gritty%20realistic%20style%2C%20rural%20mountain%20background%2C%20determined%20expressions%2C%20warm%20earthy%20tones%2C%20inspiring%20sports%20drama%20film%20poster&width=400&height=560&seq=movie-010&orientation=portrait',
    description: '向腾辉倾注心血想把当地无人照料的孩子培养成才，这让生活本没有出路的孩子们看到了通往未来的曙光。然而往日的表演视频被爆出，这些残酷血腥的画面刺激着不明真相的人们的神经。',
    director: '王宝强',
    actors: ['王宝强', '陈永胜', '史彭元', '王迅'],
    region: '中国大陆',
    duration: '117分钟',
    updateDate: '2024-11-20',
    episodes: '1',
    isHot: false,
    isNew: false,
    tags: ['剧情', '动作', '运动'],
  },
];

export const tvShows: Movie[] = [
  {
    id: 'tv-001',
    title: '狂飙',
    year: '2023',
    category: 'tv',
    subCategory: '剧情',
    rating: '8.5',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20The%20Knockout%2C%20two%20men%20facing%20off%20in%20dark%20alley%2C%20police%20versus%20gangster%20theme%2C%20tense%20confrontation%2C%20dark%20blue%20and%20amber%20lighting%2C%20gritty%20realistic%20style%2C%20TV%20series%20poster%20design&width=400&height=560&seq=tv-001&orientation=portrait',
    description: '一部以扫黑除恶为主题的电视剧，讲述了刑警安欣与黑恶势力长达二十年的生死较量。从一名普通警察到扫黑英雄，安欣付出了青春、爱情和事业的代价。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-12-18',
    episodes: '39集全',
    isHot: true,
    isNew: false,
    tags: ['剧情', '犯罪', '悬疑'],
  },
  {
    id: 'tv-002',
    title: '庆余年第二季',
    year: '2024',
    category: 'tv',
    subCategory: '古装',
    rating: '8.2',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20poster%20Joy%20of%20Life%20Season%202%2C%20ancient%20Chinese%20palace%20setting%20with%20scholar%20in%20robes%2C%20elegant%20traditional%20costume%2C%20dramatic%20lighting%20with%20warm%20gold%20tones%2C%20mysterious%20court%20intrigue%20atmosphere%2C%20premium%20TV%20series%20poster&width=400&height=560&seq=tv-002&orientation=portrait',
    description: '范闲从北齐归来后，发现自己深陷更大的阴谋之中。面对各方势力的角逐，范闲在朝堂与江湖之间游走，一步步揭开隐藏在庆国权力中心的秘密。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-12-22',
    episodes: '36集全',
    isHot: true,
    isNew: true,
    tags: ['古装', '奇幻', '剧情'],
  },
  {
    id: 'tv-003',
    title: '三体',
    year: '2023',
    category: 'tv',
    subCategory: '科幻',
    rating: '8.3',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20Three-Body%2C%20cosmic%20theme%20with%20three%20suns%20and%20mysterious%20planet%2C%20deep%20space%20background%2C%20scientists%20looking%20at%20strange%20phenomenon%2C%20cold%20blue%20and%20purple%20cosmic%20tones%2C%20intellectual%20sci-fi%20aesthetic%2C%20TV%20series%20poster&width=400&height=560&seq=tv-003&orientation=portrait',
    description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入名为科学边界的组织，接触到一个名为三体的神秘文明。人类文明与三体文明的冲突即将拉开序幕。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-11-05',
    episodes: '30集全',
    isHot: false,
    isNew: false,
    tags: ['科幻', '悬疑', '剧情'],
  },
  {
    id: 'tv-004',
    title: '繁花',
    year: '2024',
    category: 'tv',
    subCategory: '剧情',
    rating: '8.7',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20TV%20series%20poster%20Blossoms%20Shanghai%2C%201990s%20Shanghai%20street%20scene%20with%20neon%20lights%2C%20stylish%20businessman%20in%20vintage%20suit%2C%20nostalgic%20retro%20atmosphere%2C%20warm%20golden%20tones%20with%20urban%20night%20vibe%2C%20elegant%20premium%20TV%20series%20poster&width=400&height=560&seq=tv-004&orientation=portrait',
    description: '九十年代的上海，阿宝凭借自己的智慧和机遇，从一个普通青年成长为商界大佬。在这条充满机遇与挑战的道路上，他遇到了各色人等，经历了商海沉浮。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-12-15',
    episodes: '30集全',
    isHot: true,
    isNew: false,
    tags: ['剧情', '年代', '爱情'],
  },
  {
    id: 'tv-005',
    title: '长相思',
    year: '2023',
    category: 'tv',
    subCategory: '古装',
    rating: '7.8',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20drama%20poster%20Lost%20You%20Forever%2C%20ancient%20Chinese%20beauty%20in%20flowing%20robes%2C%20romantic%20mythological%20theme%2C%20peach%20blossom%20garden%20setting%2C%20soft%20dreamy%20pastel%20colors%2C%20ethereal%20fantasy%20aesthetic%2C%20TV%20series%20poster&width=400&height=560&seq=tv-005&orientation=portrait',
    description: '在上古时代，人、神、妖混居。皓翎国王姬玖瑶流落大荒，历经百年颠沛之苦后，在清水镇落脚，化身玟小六悬壶济世，与西炎王孙玱玹不期而遇。',
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-10-12',
    episodes: '39集全',
    isHot: false,
    isNew: false,
    tags: ['古装', '爱情', '奇幻'],
  },
  {
    id: 'tv-006',
    title: '与凤行',
    year: '2024',
    category: 'tv',
    subCategory: '古装',
    rating: '7.9',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20TV%20drama%20poster%20The%20Legend%20of%20ShenLi%2C%20female%20warrior%20with%20phoenix%20wings%20in%20ancient%20Chinese%20armor%2C%20celestial%20palace%20background%2C%20dramatic%20red%20and%20gold%20tones%2C%20mythological%20fantasy%20theme%2C%20epic%20TV%20series%20poster%20design&width=400&height=560&seq=tv-006&orientation=portrait',
    description: '灵界碧苍王沈璃因逃婚被打回凤凰原形，坠落人间被凡人行止买下。两人在相处中暗生情愫，然而沈璃的真实身份和肩负的使命注定了这段感情的曲折。',
    director: '邓科',
    actors: ['赵丽颖', '林更新', '何与', '辛云来'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-12-08',
    episodes: '39集全',
    isHot: false,
    isNew: true,
    tags: ['古装', '奇幻', '爱情'],
  },
  {
    id: 'tv-007',
    title: '莲花楼',
    year: '2023',
    category: 'tv',
    subCategory: '武侠',
    rating: '8.2',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%20TV%20drama%20poster%20Mysterious%20Lotus%20Casebook%2C%20swordsman%20in%20white%20robes%20with%20sword%2C%20ancient%20Chinese%20landscape%20with%20lotus%20pond%2C%20mysterious%20atmosphere%2C%20ink%20wash%20painting%20style%2C%20elegant%20traditional%20Chinese%20aesthetic%2C%20TV%20series%20poster&width=400&height=560&seq=tv-007&orientation=portrait',
    description: '十年前四顾门门主李相夷以相夷太剑冠绝天下，为正道武林之光。却因与金鸳盟盟主笛飞声约战东海后消失。十年后江湖游医李莲花拖着一座莲花楼行走世间，误打误撞得了个神医的名头。',
    director: '郭虎',
    actors: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-09-28',
    episodes: '40集全',
    isHot: false,
    isNew: false,
    tags: ['武侠', '悬疑', '古装'],
  },
  {
    id: 'tv-008',
    title: '猎罪图鉴2',
    year: '2024',
    category: 'tv',
    subCategory: '悬疑',
    rating: '8.0',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20investigation%20TV%20drama%20poster%20Under%20the%20Skin%20Season%202%2C%20forensic%20artist%20sketching%20suspect%2C%20police%20investigation%20theme%2C%20dark%20office%20with%20evidence%20board%2C%20tense%20thriller%20atmosphere%2C%20cool%20blue%20and%20white%20tones%2C%20TV%20series%20poster&width=400&height=560&seq=tv-008&orientation=portrait',
    description: '模拟画像师沈翊和刑警队长杜城联手侦破多起离奇疑案，通过画像技术追踪真相。第二季中两人面临更复杂的案件，也揭开了更多尘封的秘密。',
    director: '邢键钧',
    actors: ['檀健次', '张柏嘉', '朱嘉琦', '陆妍淇'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-12-05',
    episodes: '28集全',
    isHot: false,
    isNew: true,
    tags: ['悬疑', '犯罪', '剧情'],
  },
  {
    id: 'tv-009',
    title: '玫瑰的故事',
    year: '2024',
    category: 'tv',
    subCategory: '都市',
    rating: '8.1',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20romance%20TV%20drama%20poster%20The%20Tale%20of%20Rose%2C%20elegant%20woman%20in%20modern%20city%20setting%2C%20fashionable%20urban%20lifestyle%2C%20soft%20romantic%20lighting%20with%20rose%20flowers%2C%20contemporary%20romance%20aesthetic%2C%20premium%20TV%20series%20poster%20design&width=400&height=560&seq=tv-009&orientation=portrait',
    description: '黄亦玫出生于书香世家，从小在呵护中长大。进入职场后，她先后经历了三段感情，在每一段感情中，她都获得了不同的成长，最终活出了真正的自我。',
    director: '汪俊',
    actors: ['刘亦菲', '佟大为', '林更新', '万茜'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-11-30',
    episodes: '38集全',
    isHot: true,
    isNew: false,
    tags: ['都市', '爱情', '剧情'],
  },
  {
    id: 'tv-010',
    title: '长相思第二季',
    year: '2024',
    category: 'tv',
    subCategory: '古装',
    rating: '7.6',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20drama%20poster%20Lost%20You%20Forever%20Season%202%2C%20royal%20palace%20garden%20with%20crimson%20blossoms%2C%20ancient%20Chinese%20noblewoman%20in%20elaborate%20costume%2C%20tragic%20romance%20atmosphere%2C%20rich%20warm%20colors%2C%20premium%20fantasy%20TV%20series%20poster&width=400&height=560&seq=tv-010&orientation=portrait',
    description: '第二季中，小夭恢复了皓翎王姬的身份，各方势力对她的争夺更加激烈。她在玱玹、涂山璟和相柳之间的感情纠葛也进入了白热化阶段。',
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    region: '中国大陆',
    duration: '45分钟/集',
    updateDate: '2024-12-12',
    episodes: '23集全',
    isHot: false,
    isNew: true,
    tags: ['古装', '爱情', '奇幻'],
  },
];

export const varietyShows: Movie[] = [
  {
    id: 'variety-001',
    title: '奔跑吧第八季',
    year: '2024',
    category: 'variety',
    subCategory: '户外真人秀',
    rating: '7.2',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20Keep%20Running%20Season%208%2C%20group%20of%20celebrities%20running%20outdoors%20in%20colorful%20sportswear%2C%20fun%20energetic%20atmosphere%2C%20bright%20sunny%20day%2C%20cheerful%20expressions%2C%20entertainment%20show%20poster%20design&width=400&height=560&seq=variety-001&orientation=portrait',
    description: '《奔跑吧》是一档大型户外竞技真人秀节目。第八季继续由常驻MC带领嘉宾们进行各种趣味游戏和挑战，在欢笑与汗水中传递正能量。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞', '张真源'],
    region: '中国大陆',
    duration: '100分钟/期',
    updateDate: '2024-12-18',
    episodes: '12期全',
    isHot: true,
    isNew: false,
    tags: ['真人秀', '户外', '竞技'],
  },
  {
    id: 'variety-002',
    title: '向往的生活第七季',
    year: '2023',
    category: 'variety',
    subCategory: '慢综艺',
    rating: '8.0',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20slow-paced%20variety%20show%20poster%20Back%20to%20Field%20Season%207%2C%20countryside%20farmhouse%20with%20green%20fields%2C%20peaceful%20rural%20life%20theme%2C%20warm%20sunset%20lighting%2C%20cozy%20natural%20atmosphere%2C%20Chinese%20countryside%20aesthetic%2C%20variety%20show%20poster&width=400&height=560&seq=variety-002&orientation=portrait',
    description: '《向往的生活》是一档生活服务纪实节目。第七季中，黄磊、何炅等人回归田园，自己动手丰衣足食，招待远道而来的客人，在平凡的日常生活中寻找不平凡的美好。',
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    region: '中国大陆',
    duration: '90分钟/期',
    updateDate: '2024-08-15',
    episodes: '14期全',
    isHot: false,
    isNew: false,
    tags: ['慢综艺', '生活', '美食'],
  },
  {
    id: 'variety-003',
    title: '歌手2024',
    year: '2024',
    category: 'variety',
    subCategory: '音乐',
    rating: '8.1',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20show%20poster%20Singer%202024%2C%20spotlight%20on%20stage%20with%20microphone%2C%20dramatic%20concert%20lighting%2C%20music%20performance%20theme%2C%20golden%20and%20dark%20stage%20colors%2C%20premium%20music%20show%20poster%20design&width=400&height=560&seq=variety-003&orientation=portrait',
    description: '《歌手2024》是一档顶级音乐竞技节目。汇聚国内外实力唱将，以现场直播的形式进行多轮比拼，用最纯粹的音乐打动观众，决出年度歌王。',
    director: '洪啸',
    actors: ['那英', '汪苏泷', '周深', '单依纯', '陈楚生', '张碧晨'],
    region: '中国大陆',
    duration: '120分钟/期',
    updateDate: '2024-12-20',
    episodes: '12期全',
    isHot: true,
    isNew: true,
    tags: ['音乐', '竞技', '直播'],
  },
  {
    id: 'variety-004',
    title: '王牌对王牌第八季',
    year: '2024',
    category: 'variety',
    subCategory: '室内综艺',
    rating: '7.5',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20poster%20Trump%20Card%20Season%208%2C%20studio%20set%20with%20colorful%20game%20props%2C%20celebrities%20playing%20fun%20games%2C%20comedic%20expressions%2C%20bright%20studio%20lighting%2C%20entertainment%20show%20poster%20design&width=400&height=560&seq=variety-004&orientation=portrait',
    description: '《王牌对王牌》是一档大型原创室内竞技真人秀节目。第八季中沈腾、贾玲、华晨宇、关晓彤继续组成王牌家族，与嘉宾队伍展开才艺和游戏的激烈比拼。',
    director: '吴彤',
    actors: ['沈腾', '华晨宇', '关晓彤', '宋亚轩'],
    region: '中国大陆',
    duration: '100分钟/期',
    updateDate: '2024-11-08',
    episodes: '12期全',
    isHot: false,
    isNew: false,
    tags: ['真人秀', '竞技', '喜剧'],
  },
  {
    id: 'variety-005',
    title: '极限挑战第十季',
    year: '2024',
    category: 'variety',
    subCategory: '户外真人秀',
    rating: '7.0',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20challenge%20variety%20show%20poster%20Go%20Fighting%20Season%2010%2C%20city%20adventure%20theme%20with%20celebrities%20in%20urban%20setting%2C%20exciting%20mission%20atmosphere%2C%20modern%20city%20skyline%20background%2C%20dynamic%20action%20pose%2C%20entertainment%20show%20poster&width=400&height=560&seq=variety-005&orientation=portrait',
    description: '《极限挑战》是一档大型励志体验真人秀节目。第十季中极挑成员在全新任务中展现智慧与勇气，在城市与自然之间完成各种看似不可能完成的挑战。',
    director: '施嘉宁',
    actors: ['黄晓明', '黄景瑜', '龚俊', '黄明昊', '贾乃亮'],
    region: '中国大陆',
    duration: '90分钟/期',
    updateDate: '2024-12-14',
    episodes: '12期全',
    isHot: false,
    isNew: false,
    tags: ['真人秀', '户外', '竞技'],
  },
  {
    id: 'variety-006',
    title: '乘风2024',
    year: '2024',
    category: 'variety',
    subCategory: '音乐',
    rating: '7.8',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20female%20singers%20survival%20show%20poster%20Ride%20the%20Wind%202024%2C%20women%20performers%20on%20grand%20stage%20with%20glamorous%20costumes%2C%20girl%20power%20theme%2C%20sparkling%20stage%20effects%2C%20elegant%20and%20powerful%20atmosphere%2C%20music%20show%20poster&width=400&height=560&seq=variety-006&orientation=portrait',
    description: '《乘风2024》是一档关注女性成长与蜕变的励志综艺。邀请多位实力女艺人，通过舞台竞演的形式，展现女性的多元魅力与无限可能。',
    director: '任洋',
    actors: ['宁静', '那英', '张雨绮', '万茜', '张含韵', '金晨'],
    region: '中国大陆',
    duration: '120分钟/期',
    updateDate: '2024-10-20',
    episodes: '12期全',
    isHot: false,
    isNew: false,
    tags: ['音乐', '选秀', '女性'],
  },
  {
    id: 'variety-007',
    title: '密室大逃脱第六季',
    year: '2024',
    category: 'variety',
    subCategory: '推理',
    rating: '8.3',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20escape%20room%20variety%20show%20poster%20Great%20Escape%20Season%206%2C%20dark%20mysterious%20room%20with%20puzzle%20elements%2C%20flashlight%20beams%20in%20darkness%2C%20spooky%20atmosphere%20with%20suspense%2C%20mystery%20solving%20theme%2C%20immersive%20thriller%20show%20poster&width=400&height=560&seq=variety-007&orientation=portrait',
    description: '《密室大逃脱》是一档实景解密体验秀。第六季中密逃团继续深入各种主题的密逃空间，通过团队协作和智慧推理破解层层谜题，找到逃脱的关键线索。',
    director: '何舒',
    actors: ['杨幂', '黄明昊', '大张伟', '张国伟', '许凯'],
    region: '中国大陆',
    duration: '90分钟/期',
    updateDate: '2024-11-25',
    episodes: '13期全',
    isHot: false,
    isNew: true,
    tags: ['推理', '悬疑', '真人秀'],
  },
  {
    id: 'variety-008',
    title: '哈哈哈哈哈第四季',
    year: '2024',
    category: 'variety',
    subCategory: '旅行',
    rating: '7.9',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20travel%20variety%20show%20poster%20HaHaHaHaHa%20Season%204%2C%20friends%20road%20trip%20across%20China%20landscapes%2C%20funny%20comedic%20group%20photo%2C%20beautiful%20natural%20scenery%20background%2C%20joyful%20travel%20atmosphere%2C%20bright%20vibrant%20colors%2C%20entertainment%20show%20poster&width=400&height=560&seq=variety-008&orientation=portrait',
    description: '《哈哈哈哈哈》是一档公路旅行真人秀。第四季中，五位好友继续开启全新的旅行，在沿途的城市和乡村中体验不同的生活，制造无数欢声笑语。',
    director: '王征宇',
    actors: ['邓超', '陈赫', '鹿晗', '范志毅', '王勉'],
    region: '中国大陆',
    duration: '90分钟/期',
    updateDate: '2024-12-02',
    episodes: '12期全',
    isHot: false,
    isNew: true,
    tags: ['旅行', '真人秀', '喜剧'],
  },
];

export const allContent: Movie[] = [...movies, ...tvShows, ...varietyShows];

export const categoryMap: Record<string, { label: string; slug: string }> = {
  movie: { label: '电影', slug: 'movie' },
  tv: { label: '电视剧', slug: 'tv' },
  variety: { label: '综艺', slug: 'variety' },
};

export const subCategoryMap: Record<string, string[]> = {
  movie: ['全部', '科幻', '剧情', '战争', '动画', '犯罪', '悬疑', '喜剧', '奇幻', '动作'],
  tv: ['全部', '剧情', '古装', '科幻', '年代', '爱情', '奇幻', '武侠', '悬疑', '都市'],
  variety: ['全部', '户外真人秀', '慢综艺', '音乐', '室内综艺', '推理', '旅行', '选秀'],
};